import React, { useEffect } from "react";
import AboutAreaFour from "../components/AboutAreaFour";
import BannerFour from "../components/BannerFour";
import TestimonialOne from "../components/TestimonialOne";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import TeamAreaTwo from "../components/TeamAreaTwo";
import ServiceAreaGroup from "../components/ServiceAreaGroup";
import CareerAreaOne from "../components/CareerAreaOne";

const HomeFour = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Navigation Bar */}
      <NavbarThree />

      {/* Banner Four */}
      <BannerFour />

      {/* About Area Four */}
      <AboutAreaFour />

      {/* Carrer Area Four */}
      <CareerAreaOne />

      {/* Service Area Group */}
      <ServiceAreaGroup />

      {/* Team Area Two */}
      <TeamAreaTwo />

      {/* Career Area One */}
      <TestimonialOne />

      {/* Footer Three */}
      <FooterThree />
    </>
  );
};

export default HomeFour;
